module.exports = __webpack_public_path__ + "static/media/unassigned.9e71ed31.svg";